import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import styles from './EmptyState.module.css'

type EmptyStateProps = {
  title: string
  description?: string
  /** A lucide icon element, already sized. */
  icon?: ReactNode
  /** The one thing to do next — a Button or a Link styled with buttonClass(). */
  action?: ReactNode
  className?: string | undefined
}

/**
 * The designed blank screen. A user with no games must never see an empty
 * container: say what is missing and give exactly one way forward.
 */
export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div className={clsx(styles.empty, className)}>
      {icon !== undefined && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      <p className={styles.title}>{title}</p>
      {description !== undefined && <p className={styles.description}>{description}</p>}
      {action !== undefined && <div className={styles.action}>{action}</div>}
    </div>
  )
}
